import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  blockIcon: {
    fontSize: 13,
    color: theme.palette.error.secondary,
    marginLeft: theme.spacing(2),
  },
}));
